import { SpartaxAuftragskunde } from "./spartax-auftragskunde.dto";
import { SpartaxKind } from "./spartax-kunde.dto";

//WARNING - Types MUST be kept in Sync between the Spartax Azure Function Project and with the ones in Beeexpert manually

export enum SpartaxCQQuestionType {
    Familienstand = 'Familienstand',
    Kinder = 'Kinder',
    Einkuenfte = 'Einkuenfte',
    Behinderungen = 'Behinderungen',
}

export type SpartaxCQQuestionDetail = {
    Level: '1' | '2';
    Text: string;
    Value?: boolean;
};

export type SpartaxCQQuestionPerson = {
    Name: string;
    Geschlecht?: 'Männlich' | 'Weiblich' | 'Divers';
    IstKind: boolean;
    Details: SpartaxCQQuestionDetail[];
};

export type SpartaxCQQuestion = {
    MasterQuestionType: SpartaxCQQuestionType;
    Personen: SpartaxCQQuestionPerson[];
};

//Note: This file defines the data transfer object for customer questionnaire base data. 
//We do not use direct references to e.g. SpartaxPartner here to avoid disclosure of sensitive information.
export type SpartaxCQBaseDataDto = {
    PartnerId: number;
    PartnerName: string;
    PartnerAdresse: string;
    PartnerPLZ: string;
    PartnerOrt: string;
    PartnerTelefon: string;
    PartnerEmail: string;
    NewOrderPossible: boolean;
    ReferenceOrderFormId: string;
    ReferenceOrderFormFilloutId: string;
    ReferenceOrderListItemId: number;
    ReferenceOrderYears: string;
    ReferenceOrderYearsArray: number[];
    ReferenceOrderAuftragskunden: SpartaxAuftragskunde[];
    ReferenceOrderKinder: SpartaxKind[];
    MasterQuestions: SpartaxCQQuestion[];
    CustomerPortalSignupType: 'none' | 'email' | 'phone';
    CustomerDisplayName: string;
    CustomerEmail: string;
    CustomerPhone: string;
};

export type SpartaxCQRefDto = {
    ValidUntil: number,
    KundeFormModelId: string;
};
